import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { SellerBadge } from '@fiverr-private/listings';
import { FederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { Fade } from '@fiverr-private/transition';
import { Text, Typography } from '@fiverr-private/typography';

interface HeadingProps {
    withAvatar?: boolean;
}

export const OverviewHeading: React.FC<HeadingProps> = ({ withAvatar = false }) => {
    const { isPro, displayName, username } = useSellerData(selectSellerSlice);

    return (
        <Stack direction="column" gap="1" minHeight="60px">
            <Stack gap="2">
                <Typography color="black" size="b_md">
                    {displayName}
                </Typography>
                {isPro && (
                    <Fade in={withAvatar}>
                        <div>
                            <SellerBadge badge={SellerBadge.BADGES.PRO} dataTestId={undefined} />
                        </div>
                    </Fade>
                )}
            </Stack>
            <Text color="bodySecondary">{`@${username}`}</Text>
        </Stack>
    );
};

const selectSellerSlice = (seller: FederatedSeller) => ({
    isPro: seller.isPro,
    displayName: seller.user.profile.displayName,
    username: seller.user.name,
});
